/** @format */

'use strict';

angular.module('emsApp').config(function($stateProvider) {
	/**
	 * Add all translations for a 'CarRentalTypeTemplateEventArticle'
	 */
	var getTranslations = function($translate, $translatePartialLoader) {
		$translatePartialLoader.addPart('carrentaltypetemplateeventarticle'); // main translation loaded for carrentaltypetemplateeventarticle
		$translatePartialLoader.addPart('carrentaltype'); // one to many reference from main entity
		$translatePartialLoader.addPart('templateevent'); // one to many reference from main entity
		$translatePartialLoader.addPart('article'); // one to many reference from main entity

		return $translate.refresh();
	};

	/**
	 * "private" function called by wrapper new and edit functions.
	 */
	var getModalState = function(url, isEditMode) {
		if (!angular.isDefined(url) || url === null) {
			url = '/new';
		}

		if (!angular.isDefined(isEditMode) || isEditMode === null) {
			// default mode is NEW, however this situation should and will be avoided by as this function should only be
			isEditMode = false;
		}

		var templateUrl;
		// The default assignment to templateUrl can be overridden in hook custom/jhipster/state/template_url/add_or_edit.ftl
		templateUrl = 'app/entities/carrentaltypetemplateeventarticle/carrentaltypetemplateeventarticle-dialog.html';

		return {
			/* new state for entity carRentalTypeTemplateEventArticle */
			/* to access: ui-ref="carrentaltypetemplateeventarticle.list.new" */
			/* url: hostname/carrentaltypetemplateeventarticle/new */
			url: url,
			data: {
				authorities: ['ROLE_USER'],
				isModal: true,
			},
			params: {
				mappedBy: null,
				mappedByType: null,
				mappedById: null,
				dataModel: null, // this data model is set from the new relation state OR from the save and new logic
				mappedByDisplayValue: null,
				dataModelType: null, // this data model type is the name of the modelobject, lowercase

				hiddenParam: 'YES', // hides params from url
			},
			onEnter: [
				'$stateParams',
				'$state',
				'$uibModal',
				'$rootScope',
				function($stateParams, $state, $uibModal, $rootScope) {
					var navigateBack = true;

					$uibModal
						.open({
							templateUrl: templateUrl,
							controller: 'CarRentalTypeTemplateEventArticleDialogController',
							size: 'lg',
							backdrop: 'static',
							resolve: {
								entity: [
									'CarRentalTypeTemplateEventArticleFactory',
									'NewCarRentalTypeTemplateEventArticleFactory',
									function(CarRentalTypeTemplateEventArticleFactory, NewCarRentalTypeTemplateEventArticleFactory) {
										// NOTE either this dialog was opened with the purpose of
										// - creating a new CarRentalTypeTemplateEventArticle
										// - resuming the creation of a new new CarRentalTypeTemplateEventArticle AFTER new instances were created of x..1 reference(s)

										// if dataModel is defined, we're coming back from a new created x..1 reference
										if ($rootScope.isDefinedAndNotNull($stateParams.dataModel)) {
											var model = $stateParams.dataModel;
											// reset 'remembered' values to prevent future misbehaviour
											$rootScope.previousStateParams.dataModel = null;
											$stateParams.dataModel = null;

											// instead of returning a new model, we return the updated model
											return model;
										} else {
											if (isEditMode) {
												// get the entity by its ID
												return CarRentalTypeTemplateEventArticleFactory.get({
													id: $stateParams.carRentalTypeTemplateEventArticleId,
												}).$promise.then(
													function(data) {
														return data;
													},
													function(error) {
														return error;
													}
												);
											} else {
												// get a new empty entity
												return NewCarRentalTypeTemplateEventArticleFactory.get().$promise.then(
													function(data) {
														return data;
													},
													function(error) {
														return error;
													}
												);
											}
										}
									},
								],
								translatePartialLoader: [
									'$translate',
									'$translatePartialLoader',
									function($translate, $translatePartialLoader) {
										return getTranslations($translate, $translatePartialLoader);
									},
								],
							},
						})
						.result.then(function() {
							// process success result, if necessary
						})
						.catch(function(closeReason) {
							if (closeReason === 'createNew') {
								// only navigate back in history if the close reason allows us to
								navigateBack = false;
							}
						})
						.finally(function() {
							if (navigateBack) {
								$rootScope.back();
							}
						});
				},
			],
		};
	};

	/**
	 * Body for carRentalTypeTemplateEventArticle new state
	 */
	function getNewState(url) {
		return getModalState(url, false);
	}

	/**
	 * Body for carRentalTypeTemplateEventArticle edit state
	 */
	function getEditState(url) {
		return getModalState(url, true);
	}

	$stateProvider.state('carrentaltypetemplateeventarticle', {
		/* abstract state for entity carRentalTypeTemplateEventArticle */
		/* NOTE this state cannot be accessed directly, it must be inherited by a nested state by postpending the state name with a new state */
		abstract: true,
		parent: 'entity',
		url: '/carrentaltypetemplateeventarticle',
		data: {
			authorities: ['ROLE_USER'],
			pageTitle: 'CarRentalTypeTemplateEventArticles',
			isModal: false,
		},
		resolve: {
			translatePartialLoader: [
				'$translate',
				'$translatePartialLoader',
				function($translate, $translatePartialLoader) {
					return getTranslations($translate, $translatePartialLoader);
				},
			],
		},
	});

	$stateProvider.state('carrentaltypetemplateeventarticle.list', {
		/* list state for entity carRentalTypeTemplateEventArticle */
		/* to access: ui-ref="carrentaltypetemplateeventarticle.list" */
		/* url: hostname/carrentaltypetemplateeventarticle/list */
		url: '/list',
		views: {
			'content@': {
				templateUrl: 'app/entities/carrentaltypetemplateeventarticle/carrentaltypetemplateeventarticles.html',
				controller: 'CarRentalTypeTemplateEventArticleController',
			},
		},
	});

	$stateProvider.state('carrentaltypetemplateeventarticle.detail', {
		/* detail state for entity carRentalTypeTemplateEventArticle */
		/* to access: ui-sref="carrentaltypetemplateeventarticle.detail" */
		/* url: hostname/carrentaltypetemplateeventarticle/detail/:carRentalTypeTemplateEventArticleId */
		url: '/detail/:carRentalTypeTemplateEventArticleId',
		views: {
			'content@': {
				templateUrl: 'app/entities/carrentaltypetemplateeventarticle/carrentaltypetemplateeventarticle-detail.html',
				controller: 'CarRentalTypeTemplateEventArticleDetailController',
			},
		},
		resolve: {
			entity: [
				'$stateParams',
				'CarRentalTypeTemplateEventArticleFactory',
				function($stateParams, CarRentalTypeTemplateEventArticleFactory) {
					return CarRentalTypeTemplateEventArticleFactory.get({ id: $stateParams.carRentalTypeTemplateEventArticleId });
				},
			],
		},
	});

	/* url: http://<hostname>/carrentaltypetemplateeventarticle/list/new */
	$stateProvider.state('carrentaltypetemplateeventarticle.list.new', getNewState());
	/* url: http://<hostname>/carrentaltypetemplateeventarticle/list/:carRentalTypeTemplateEventArticleId/edit */
	$stateProvider.state('carrentaltypetemplateeventarticle.list.edit', getEditState('/:carRentalTypeTemplateEventArticleId/edit'));
	/* url: http://<hostname>/carrentaltypetemplateeventarticle/detail/:carRentalTypeTemplateEventArticleId/edit */
	$stateProvider.state('carrentaltypetemplateeventarticle.detail.edit', getEditState('/edit'));
});
